<h2>Welcome to Project Manager</h2>

<!-- <mat-tab-group class="mat-tab-sm" color="primary" backgroundColor="primary">
    <mat-tab label="Contracts">
        <app-contracts></app-contracts>
    </mat-tab>
    <mat-tab label="Customers"> Customers </mat-tab>
</mat-tab-group> -->